import { useQuery } from "@tanstack/react-query";

import { apiLongRunningRequestTimeoutMs } from "../config";
import useApiHelper from "../hooks/useApiHelper";
import { IStationCycleTimesResponse } from "../models/ProductionDashboard";

/**
 * Median cycle time per station over a date range.
 *
 * Separate from useDashboardStats on purpose: the dashboard tiles are driven by fixed
 * today/week/month tabs, while this panel has its own range picker. Sharing one query would make
 * changing the range refetch every tile.
 */
export default function useStationCycleTimes(from: string, to: string, enabled = true) {
  const { get } = useApiHelper({ timeoutMs: apiLongRunningRequestTimeoutMs });

  const cycleTimes = useQuery({
    queryKey: ["stationCycleTimes", from, to],
    queryFn: () =>
      get<IStationCycleTimesResponse>(
        `/productionmanager/cycle-times?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`
      ),
    staleTime: 1000 * 60 * 1,
    enabled: enabled && !!from && !!to,
    retry: 1,
  });

  return { cycleTimes };
}
